import { EditorContentView } from '@modules/editor/EditorContentView';
import { Typography, styled } from '@mui/material';
import { Editor } from '@tiptap/react';
import { forwardRef } from 'react';
import { useLocales } from 'src/locales';

type Props = React.HTMLProps<HTMLDivElement> & {
  editor: Editor;
  content: string;
  plaintext?: boolean;
  edited?: boolean;
};

export const ConversationMessageView = forwardRef(
  ({ editor, content, plaintext, edited, ...props }: Props, ref) => {
    const { translate } = useLocales();
    return (
      <StyledWrapper ref={ref} {...(props as any)}>
        <StyledEditorContentView
          editor={editor}
          content={content}
          plaintext={plaintext}
        />
        {edited && (
          <Typography
            variant="caption"
            color="textSecondary"
            whiteSpace="nowrap"
          >
            ({translate('shared.labels.edited')})
          </Typography>
        )}
      </StyledWrapper>
    );
  },
);

const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: theme.spacing(1),
  maxWidth: '100%',
}));

const StyledEditorContentView = styled(EditorContentView)(({ theme }) => ({
  maxWidth: '100%',
  p: {
    margin: 0,
    padding: 0,
    '&:not(:last-child)': {
      marginBottom: theme.spacing(0.5),
    },
  },
  '& :where(h1, h2, h3, h4, h5, h6):first-of-type': {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));
